import "./style.css";
import { Form } from "./components/Form";
export default function App() {
  return (
    <div className="App">
      <Form />
    </div>
  );
}
